module.exports = __webpack_public_path__ + "img/企业能源管理运行总览.445941b4.png";